// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '제뉴원사이언스',
  targetSheetName: '수수료표',
  headerRowIndex: 0,
  headerRowCount: 1,
  dataStartRowIndex: 1,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'No.',
    '계열',
    '보험코드',
    '제품명',
    '성분 / 함량',
    '대조약',
    '판매사',
    '구분',
    '5월 보험약가',
    '5월 수수료율',
    '추가 수수료',
    '비고',
  ],
});
